import { apiRequest } from './client'
import type {
  CreateManagedUserRequest,
  CreateManagedUserResponse,
  GeneratedPasswordResponse,
  ManagedUser,
  ManagedUserListResponse,
  UpdateManagedUserRequest,
} from '@/types'

function userPath(userId: string, suffix = ''): string {
  return `/api/admin/users/${encodeURIComponent(userId)}${suffix}`
}

export async function listUsers(params?: {
  limit?: number
  offset?: number
}): Promise<ManagedUserListResponse> {
  const query = new URLSearchParams()
  if (params?.limit != null) query.set('limit', String(params.limit))
  if (params?.offset != null) query.set('offset', String(params.offset))
  const qs = query.toString()
  return apiRequest<ManagedUserListResponse>(`/api/admin/users${qs ? `?${qs}` : ''}`)
}

export async function createUser(
  body: CreateManagedUserRequest,
): Promise<CreateManagedUserResponse> {
  return apiRequest<CreateManagedUserResponse>('/api/admin/users', {
    method: 'POST',
    body: JSON.stringify({
      ...body,
      username: body.username.trim().toLowerCase(),
      display_name: body.display_name?.trim() || null,
    }),
  })
}

export async function updateUser(
  userId: string,
  body: UpdateManagedUserRequest,
): Promise<ManagedUser> {
  return apiRequest<ManagedUser>(userPath(userId), {
    method: 'PATCH',
    body: JSON.stringify({
      ...body,
      ...(body.display_name !== undefined
        ? { display_name: body.display_name?.trim() || null }
        : {}),
    }),
  })
}

export async function resetUserPassword(userId: string): Promise<GeneratedPasswordResponse> {
  return apiRequest<GeneratedPasswordResponse>(userPath(userId, '/reset-password'), {
    method: 'POST',
  })
}

export async function activateUser(userId: string): Promise<ManagedUser> {
  return apiRequest<ManagedUser>(userPath(userId, '/activate'), { method: 'POST' })
}

export async function deactivateUser(userId: string): Promise<ManagedUser> {
  return apiRequest<ManagedUser>(userPath(userId, '/deactivate'), { method: 'POST' })
}
